// WDH FEATURE B2B
require("../../../../wdh-feature/wdh-feature-b2b/src/js/b2b-shop");